export const config = {
	API_DOMAIN: "http://eca-wp.local/wp-json/wp",
	CUSTOM_API_DOMAIN: "http://eca-wp.local/wp-json/eca",
	NOT_FOUND_REDIRECT_LINK: "#",
	ITEMS_PER_PAGE: 12,
};

export const changeConfig = (property, value) => (config[property] = value);
